import type { CommentableContentObject } from 'models';
import type { User } from 'features/auth';
import { isProgramAdminProfile } from 'permissions/user-roles';
import { isCommunityAdminProfile, isOrganizationAdminProfile, isSuperAdmin } from '../utils';

export const canComment = ({ contentObject, viewer }: { contentObject: CommentableContentObject; viewer: User }) => {
  if (contentObject.type === 'giving') {
    return false;
  }

  if (isSuperAdmin({ viewer: viewer.railsUserData })) {
    return true;
  }

  switch (contentObject.contentableType) {
    case 'Community':
      return (
        Boolean(contentObject.postInCommunities[0].settings.allowComments) ||
        isCommunityAdminProfile({ communityId: contentObject.postInCommunities[0].id, viewer: viewer.railsUserData }) ||
        isOrganizationAdminProfile({ organizationId: contentObject.organization.id, viewer: viewer.railsUserData })
      );

    case 'Program':
      return (
        Boolean(contentObject.program.settings?.allowComments) ||
        isProgramAdminProfile({ programId: contentObject.program.id, viewer: viewer.railsUserData }) ||
        isOrganizationAdminProfile({ organizationId: contentObject.organization.id, viewer: viewer.railsUserData })
      );
  }
};
